import { render, staticRenderFns } from "./PanelControl.vue?vue&type=template&id=679574b7&scoped=true&"
import script from "./PanelControl.vue?vue&type=script&lang=js&"
export * from "./PanelControl.vue?vue&type=script&lang=js&"
import style0 from "./PanelControl.vue?vue&type=style&index=0&id=679574b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679574b7",
  null
  
)

export default component.exports